import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLayoutEffect, useRef } from 'react';
import classNames from 'clsx';
import { useDetectOutsideClick } from '../../detect-outside-click';
import { useApplicationSize } from '../../../providers/providers-application';
import { ARROW_HEIGHT, ARROW_WIDTH, OVERLAY_MAX_WIDTH } from '../constants';
import { TooltipOverlayArrow, TooltipOverlayArrowContainer, TooltipOverlayContainer, TooltipOverlayContainerContent, TooltipOverlayContent, TooltipOverlayText, TooltipOverlayTitle, TooltipWrapper, } from '../styles/_tooltip.styled';
export const TooltipOverlay = ({ children, handleClose, position, className, title, dataTest, placement, variant, }) => {
    const applicationSize = useApplicationSize();
    const wrapperRef = useRef(null);
    const innerRef = useRef(null);
    const iconWrapperRef = useRef(null);
    const containerClassNames = classNames('PONCHO-tooltip', className);
    useDetectOutsideClick({ ref: wrapperRef, onClickOutside: handleClose });
    useLayoutEffect(() => {
        if (wrapperRef.current === null ||
            innerRef.current === null ||
            iconWrapperRef.current === null) {
            return;
        }
        if (applicationSize !== 'small') {
            let left = position.x;
            let top = position.y;
            if (placement === 'top' || placement === 'bottom') {
                const width = OVERLAY_MAX_WIDTH / 2;
                const offset = wrapperRef.current.clientWidth / 2;
                const max = document.body.clientWidth - (position.x + offset + width);
                const min = position.x + offset - width;
                left = max > 0 ? position.x : position.x + max;
                left = min > 0 ? left : left - min;
            }
            else {
                const height = innerRef.current.clientHeight / 2;
                const offset = wrapperRef.current.clientHeight / 2;
                const max = document.body.clientHeight - (position.y + offset + height);
                const min = position.y + offset - height;
                top = max > 0 ? position.y : position.y + max;
                top = min > 0 ? top : top - min;
            }
            wrapperRef.current.style.left = `${left}px`;
            wrapperRef.current.style.top = `${top}px`;
        }
        else {
            wrapperRef.current.style.top = `${position.y}px`;
        }
        iconWrapperRef.current.style.top = `${position.y}px`;
        iconWrapperRef.current.style.left = `${position.x}px`;
    }, [placement, position.x, position.y]);
    return (_jsxs(_Fragment, { children: [_jsx(TooltipWrapper, { ref: wrapperRef, children: _jsx(TooltipOverlayContainer, { "data-test": `${dataTest}-container`, className: containerClassNames, "$placement": applicationSize === 'small' ? 'bottom' : placement, children: _jsx(TooltipOverlayContainerContent, { "$variant": variant, ref: innerRef, children: _jsxs(TooltipOverlayContent, { className: "PONCHO-tooltip__content", "data-test": `${dataTest}-content`, children: [title && (_jsx(TooltipOverlayTitle, { className: "PONCHO-tooltip__content-title", "data-test": `${dataTest}-content-title`, "$variant": variant, children: title })), _jsx(TooltipOverlayText, { "data-test": `${dataTest}-content-text`, "$variant": variant, children: children })] }) }) }) }), _jsx(TooltipOverlayArrowContainer, { ref: iconWrapperRef, children: _jsx(TooltipOverlayArrow, { viewBox: `0 0 ${ARROW_WIDTH} ${ARROW_HEIGHT}`, className: "PONCHO-tooltip__arrow", "$variant": variant, "$placement": applicationSize === 'small' ? 'bottom' : placement, "$width": ARROW_WIDTH, children: _jsx("polygon", { points: `0 ${ARROW_HEIGHT}, ${ARROW_WIDTH} ${ARROW_HEIGHT}, ${ARROW_WIDTH / 2} 0` }) }) })] }));
};
